import {
  PrismicContext,
  fallbackImage,
  fallbackText,
  LinkType,
  Prismic,
} from '@landsbankinn/prismic';
import { Button, theme } from '@landsbankinn/ui';
import { hyphenateSync } from 'hyphen/is';
import Link from 'next/link';
import React, { useContext } from 'react';
import { ArticlePageHero } from '../components/hero-article/ArticlePageHero';

interface ArticleHeroContainerProps {
  a_abstract: Prismic.RichText;
  a_image: Prismic.Image;
  a_link: Prismic.Link & {
    abstract: Prismic.RichText;
    title: Prismic.RichText;
    image: Prismic.Image;
    _meta: any;
  };
  a_link_text: Prismic.RichText;
  a_title: Prismic.RichText;
}

export function ArticleHeroContainer(props: ArticleHeroContainerProps) {
  const { urlResolver } = useContext(PrismicContext);
  const titleText = fallbackText(props.a_title, props.a_link?.title);
  const abstract = fallbackText(props.a_abstract, props.a_link?.abstract);
  const image = fallbackImage(props.a_image, props.a_link?.image);
  let action = null;
  let title: string | React.ReactElement = hyphenateSync(
    Prismic.text(titleText) ?? '',
  );
  if (props.a_link) {
    const link = Prismic.link(
      urlResolver,
      {
        _linkType: LinkType.Document,
        ...(props?.a_link as any),
      },
      titleText ?? undefined,
    );
    const linkText = Prismic.text(props.a_link_text);
    action = (
      <Link href={link.as as any}>
        <Button
          {...link.anchorProps()}
          as="a"
          title={linkText ?? undefined}
          bg={theme.colors.secondary}
        />
      </Link>
    );
    title = <Link href={link.as ?? ''}>{title}</Link>;
  }
  return (
    <ArticlePageHero
      title={title}
      description={abstract ?? undefined}
      image={image}
      actions={action}
    />
  );
}
